import { I18n } from 'react-redux-i18n';

import { api, mergeParams, wrapParams } from '../../../api';
import { SHOW_LOADING, HIDE_LOADING } from '../types/loadingTypes';

export function getComponents() {


  return (dispatch) => {

    dispatch({
      type: SHOW_LOADING,
    });

    return new Promise((resolve, reject) => {

      api.get('Component/GetComponents').then((response) => {

        dispatch({
          type: HIDE_LOADING,
        });

        resolve(response.data.return);

      }, (error) => {

        dispatch({
          type: HIDE_LOADING,
        });

        reject(error.response.data.return);

      });

    });

  };

};


// WEBPACK FOOTER //
// ./src/redux/actions/tracker/componentsActions.js